/** Case-insensitive email compare for Auth0 / env super-user checks. */
export function emailsEqual(a, b) {
  if (!a || !b) return false;
  return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
}
